import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum ActionPlanKind {
  ThreeMonths = 'three_months',
}

export const actionPlanCreateSchema = z.object({
  brandId: z.string(),
  organizationId: z.string(),
  strategyId: z.string(),
  kind: z.nativeEnum(ActionPlanKind),

  startDate: z.number(),
  endDate: z.number(),

  tasksPerMonth: z.number(),

  isGenerated: z.boolean(),
});
export type ActionPlanCreate = z.infer<typeof actionPlanCreateSchema>;

export const actionPlanSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(actionPlanCreateSchema);

export type ActionPlan = z.infer<typeof actionPlanSchema>;
